import ActionTypes from "../enums/ActionTypes"
import OperationPlanState from "../enums/OperationPlanState"

interface State {
  operationPlanUpdate: {
    version: number
    operationPlanState?: OperationPlanState
    operationIds: number[]
  }
}

interface Action {
  type: keyof typeof ActionTypes
  payload: number[]
}

const initialState: State = {
  operationPlanUpdate: {
    version: 0,
    operationPlanState: undefined,
    operationIds: [],
  },
}

const updateOperationPlanState = (
  state: State,
  operationPlanState: OperationPlanState,
  operationIds: number[]
): State => ({
  ...state,
  operationPlanUpdate: {
    version: state.operationPlanUpdate.version + 1,
    operationPlanState,
    operationIds,
  },
})

export default (state: State = initialState, action: Action): State => {
  if (action.type === ActionTypes.SOCKET_RECEIVED_PLAN_ON_OPERATION_IDS) {
    return updateOperationPlanState(state, OperationPlanState.PLAN_ON, action.payload)
  }
  if (action.type === ActionTypes.SOCKET_RECEIVED_PLAN_OFF_OPERATION_IDS) {
    return updateOperationPlanState(state, OperationPlanState.PLAN_OFF, action.payload)
  }
  return state
}
